import { addAccessTokenInterceptor } from '../../api/interceptors';
import { LAST_ACTION } from '../../constants/localStorageConstants';
import { handleLogout } from '../auth';

import { LOGOUT_TIME } from './constants';

export function postLoginCallback(getAccessToken, bouncerLogout) {
  addAccessTokenInterceptor(getAccessToken);
  checkLastActionCounter(function() {
    handleLogout(bouncerLogout);
    throw new Error('The session expired due to inactivity.');
  });
}

export function checkLastActionCounter(cb) {
  const localStorageLastAction = localStorage.getItem(LAST_ACTION);
  if (localStorageLastAction) {
    const now = Date.now();
    const lastAction = JSON.parse(localStorageLastAction);
    const timeLeft = lastAction + LOGOUT_TIME;
    const diff = timeLeft - now;
    if (diff < 0) {
      cb();
    }
  }
}
